<main class="ui-portal-clientes-login">
  <section class="ui-portal-clientes-login__form-panel">
    <div class="ui-portal-clientes-login__form-card">
      <img class="ui-portal-clientes-login__logo" [src]="logoSrc()" [alt]="logoAlt()" />
      <h1 class="ui-portal-clientes-login__title">{{ title() }}</h1>

      @if (mode() === 'login') {
        <form class="ui-portal-clientes-login__form" (submit)="$event.preventDefault(); onSubmit()">
          <div class="ui-portal-clientes-login__row ui-portal-clientes-login__row--username">
            <ui-input
              label="Correo electrónico o celular"
              [required]="true"
              [showOptionalHint]="false"
              placeholder="Correo electrónico o celular"
              [value]="username()"
              (valueChange)="username.set($event)"
              [invalid]="usernameInvalid()"
              [message]="'El correo o celular es obligatorio'"
            />
          </div>

          <div class="ui-portal-clientes-login__row ui-portal-clientes-login__row--password">
            <ui-input
              label="Contraseña"
              kind="password"
              [required]="true"
              [showOptionalHint]="false"
              placeholder="Contraseña"
              [value]="password()"
              (valueChange)="password.set($event)"
              [invalid]="passwordInvalid()"
              [message]="'La contraseña es obligatoria'"
            />
          </div>

          <div class="ui-portal-clientes-login__row ui-portal-clientes-login__row--captcha">
            <ui-recaptcha
              [siteKey]="recaptchaSiteKey()"
              [theme]="recaptchaTheme()"
              [size]="recaptchaSize()"
              [language]="recaptchaLanguage()"
              [fluid]="true"
              [fitChallengeToViewport]="true"
              (resolved)="onCaptchaResolved($event)"
              (expired)="onCaptchaExpired()"
              (errored)="onCaptchaError()"
            />
            @if (captchaMessage()) {
              <ui-message
                class="ui-portal-clientes-login__captcha-message"
                variant="error"
                [message]="captchaMessage()"
                [noMarginBottom]="true"
              />
            }
          </div>

          @if (errorMessage()) {
            <div class="ui-portal-clientes-login__row ui-portal-clientes-login__row--error">
              <ui-message
                variant="error"
                [message]="errorMessage()"
                [noMarginBottom]="true"
              />
            </div>
          }

          <div class="ui-portal-clientes-login__row ui-portal-clientes-login__row--submit">
            <ui-button
              class="ui-portal-clientes-login__action-button"
              type="submit"
              variant="primary"
              size="md"
              [block]="true"
              [disabled]="!canSubmit()"
            >
              Ingresar
            </ui-button>
          </div>

          <div class="ui-portal-clientes-login__row ui-portal-clientes-login__row--forgot">
            <ui-button
              class="ui-portal-clientes-login__action-button"
              type="button"
              variant="ghost"
              size="md"
              [block]="true"
              (pressed)="forgotPassword.emit()"
            >
              Recuperar contraseña
            </ui-button>
          </div>

          @if (showSupplierRegister()) {
            <div class="ui-portal-clientes-login__row">
              <ui-button
                class="ui-portal-clientes-login__action-button"
                type="button"
                variant="white"
                size="md"
                [block]="true"
                (pressed)="supplierRegister.emit()"
              >
                Registro
              </ui-button>
            </div>
          }
        </form>
      } @else if (mode() === 'personalize') {
        <form
          class="ui-portal-clientes-login__form"
          (submit)="$event.preventDefault(); onPersonalizeSubmit()"
        >
          <p class="ui-portal-clientes-login__hint">
            Antes de continuar, define una contraseña segura.
          </p>

          <div class="ui-portal-clientes-login__row ui-portal-clientes-login__row--username">
            <ui-input
              label="Nueva contraseña"
              kind="password"
              [required]="true"
              [showOptionalHint]="false"
              placeholder="Nueva contraseña"
              [value]="newPassword()"
              (valueChange)="newPassword.set($event)"
              [showPasswordRules]="true"
            />
          </div>

          <div class="ui-portal-clientes-login__row ui-portal-clientes-login__row--password">
            <ui-input
              label="Confirmar contraseña"
              kind="password"
              [required]="true"
              [showOptionalHint]="false"
              placeholder="Confirmar contraseña"
              [value]="confirmPassword()"
              (valueChange)="confirmPassword.set($event)"
              [matchValue]="newPassword()"
            />

          </div>

          <div class="ui-portal-clientes-login__row ui-portal-clientes-login__row--submit">
            <ui-button
              class="ui-portal-clientes-login__action-button"
              type="submit"
              variant="primary"
              size="md"
              [block]="true"
              [disabled]="!canSubmitPersonalize()"
            >
              Continuar
            </ui-button>
          </div>

          <div class="ui-portal-clientes-login__row">
            <ui-button
              class="ui-portal-clientes-login__action-button"
              type="button"
              variant="ghost"
              size="md"
              [block]="true"
              (pressed)="onBackToLogin()"
            >
              Regresar
            </ui-button>
          </div>
        </form>
      } @else {
        @switch (recoverStep()) {
          @case (1) {
            <form
              class="ui-portal-clientes-login__form"
              (submit)="$event.preventDefault(); onRecoverSendCode()"
            >
              <div class="ui-portal-clientes-login__row ui-portal-clientes-login__row--password">
                <ui-input
                  label="Correo electrónico o celular"
                  [required]="true"
                  [showOptionalHint]="false"
                  placeholder="Correo electrónico o celular"
                  [value]="recoverContact()"
                  (valueChange)="recoverContact.set($event)"
                />
              </div>

              <div class="ui-portal-clientes-login__row ui-portal-clientes-login__row--submit">
                <ui-button
                  class="ui-portal-clientes-login__action-button"
                  type="submit"
                  variant="primary"
                  size="md"
                  [block]="true"
                  [disabled]="!canSendRecoverCode()"
                >
                  Enviar código
                </ui-button>
              </div>

              <div class="ui-portal-clientes-login__row">
                <ui-button
                  class="ui-portal-clientes-login__action-button"
                  type="button"
                  variant="ghost"
                  size="md"
                  [block]="true"
                  (pressed)="onBackToLogin()"
                >
                  Regresar
                </ui-button>
              </div>
            </form>
          }
          @case (2) {
            <form
              class="ui-portal-clientes-login__form"
              (submit)="$event.preventDefault(); onRecoverValidateCode()"
            >
              <div class="ui-portal-clientes-login__row ui-portal-clientes-login__row--code">
                <ui-code-input
                  label="Código de recuperación"
                  [required]="true"
                  [showOptionalHint]="false"
                  [value]="recoverCode()"
                  (valueChange)="recoverCode.set($event)"
                />
              </div>

              <div class="ui-portal-clientes-login__row ui-portal-clientes-login__row--submit">
                <ui-button
                  class="ui-portal-clientes-login__action-button"
                  type="submit"
                  variant="primary"
                  size="md"
                  [block]="true"
                  [disabled]="!canValidateRecoverCode()"
                >
                  Validar código
                </ui-button>
              </div>

              <div class="ui-portal-clientes-login__row">
                <ui-button
                  class="ui-portal-clientes-login__action-button"
                  type="button"
                  variant="ghost"
                  size="md"
                  [block]="true"
                  (pressed)="onBackToLogin()"
                >
                  Regresar
                </ui-button>
              </div>
            </form>
          }
          @default {
            <form
              class="ui-portal-clientes-login__form"
              (submit)="$event.preventDefault(); onRecoverSavePassword()"
            >
              <p class="ui-portal-clientes-login__hint">
                Define una contraseña segura.
              </p>

              <div class="ui-portal-clientes-login__row ui-portal-clientes-login__row--username">
                <ui-input
                  label="Nueva contraseña"
                  kind="password"
                  [required]="true"
                  [showOptionalHint]="false"
                  placeholder="Nueva contraseña"
                  [value]="newPassword()"
                  (valueChange)="newPassword.set($event)"
                  [showPasswordRules]="true"
                />
              </div>

              <div class="ui-portal-clientes-login__row ui-portal-clientes-login__row--password">
                <ui-input
                  label="Confirmar contraseña"
                  kind="password"
                  [required]="true"
                  [showOptionalHint]="false"
                  placeholder="Confirmar contraseña"
                  [value]="confirmPassword()"
                  (valueChange)="confirmPassword.set($event)"
                  [matchValue]="newPassword()"
                />
              </div>

              <div class="ui-portal-clientes-login__row ui-portal-clientes-login__row--submit">
                <ui-button
                  class="ui-portal-clientes-login__action-button"
                  type="submit"
                  variant="primary"
                  size="md"
                  [block]="true"
                  [disabled]="!canSubmitPersonalize()"
                >
                  Guardar
                </ui-button>
              </div>

              <div class="ui-portal-clientes-login__row">
                <ui-button
                  class="ui-portal-clientes-login__action-button"
                  type="button"
                  variant="ghost"
                  size="md"
                  [block]="true"
                  (pressed)="onBackToLogin()"
                >
                  Regresar
                </ui-button>
              </div>
            </form>
          }
        }
      }
    </div>
  </section>

  <section class="ui-portal-clientes-login__banner-panel" aria-label="Imagen del portal">
    <img class="ui-portal-clientes-login__banner" [src]="bannerSrc()" [alt]="bannerAlt()" />
    <p class="ui-portal-clientes-login__banner-text">
      Damos certeza<br />
      inmobiliaria
    </p>
  </section>
</main>
